import { Injectable, inject, signal, computed, untracked, ChangeDetectorRef } from '@angular/core';
import { validate } from 'class-validator';
import { JkBDbService } from './jkBdb';
import { login, LoginService } from './jkUser';
import { Observable, of } from 'rxjs';
import { ColDef } from 'ag-grid-community';
import { jkLib, jkLibClass } from './jkCommon';
import { CR, idNameItem, JkEnvironment, jkRestReturn, PageKind } from './jkInterface';
import { jkAlert, jkRestReturnClass, SqlOption } from './jkClass';
import { OrmService } from '../services/jkOrm';
import { entityState, entityStateName, EntityType, JkEntityType, loadBodyOption, validateClass, validType } from './jkEntityTypes';

/** table種類: master:單頭 detail:單身 foot:子單身 data:基本資料 */


// 合併 pkgTableClass 功能
@Injectable({
  providedIn: 'root'
})
export class JkEntityV2 extends jkLibClass {
  topN: number = 1000;
  //env!: JkEnvironment;
  //jkRet: jkRestReturn;
  cdr!: ChangeDetectorRef;
  login: LoginService; // = inject(LoginService);
  jkBDb: JkBDbService = inject(JkBDbService);
  orm: OrmService = inject(OrmService);
  isOpenWin: boolean = false;
  //dataSet!: DataSource;
  isBatchMode: boolean = false;// 要考慮 entityType,entityState
  idNameList: idNameItem[] = [];
  idNameOpt: SqlOption = new SqlOption();
  private _itemList = signal<Array<any>>([]);
  public readonly itemList = this._itemList.asReadonly();
  // 如何新增一個項目
  public pushItem(newItem: any) {
    // 回傳一個包含新項目的新陣列
    this.setItemList([...this.itemList(), newItem]);
  }
  public updateItem(index: number, updatedItem: any) { // FIXME: this.item 會跳到第一筆
    const currentList = [...this.itemList()];
    currentList[index] = updatedItem;
    this.setItemList(currentList);
  }


  /* 當您在其他元件或服務中使用 jkEntityV2.itemList 時，
  您可以將它傳遞給 effect() 或 computed()，
  Angular 的響應式系統就能正確地追蹤其變化。
  */
  public setItemList(value: Array<any>): void {
    this._itemList.set(value);
    if (value && value.length > 0) {
      if (!this.item) { // jackie 20260126 add
        this.item = value[0];
      }
      /*if(this.onAfterScroll){
        this.onAfterScroll(this.item,this.ret);
      }*/
    } else {
      this.item = undefined;
    }
    if (this.onAfterOpen) {
      this.onAfterOpen(this.item, this.ret);
    }
    if (this.onUIRefresh) {
      this.onUIRefresh();
    }
  }
  cloneList: Array<any> = [];
  private _item = signal<any>(undefined); // 由搬 baseForm 搬過來

  public get item(): any {
    let currentItem = this._item();
    // 使用 untracked 來避免在模板渲染期間寫入信號
    if (!currentItem) {
      return untracked(() => {
        const itemList = this.itemList();
        if (itemList.length > 0) {
          currentItem = itemList[0];
          this._item.set(currentItem);
        } else {
          currentItem = {}; // 用 undefined 在 html item.欄位 會出錯
          this._item.set(currentItem);
        }
        return currentItem;
      });
    }
    return currentItem;
  }

  public set item(value: any) {
    //jkLib.cloneField(value, this.oldItem);
    if (!value) {
      return;
    }
    const currentItem = untracked(this._item);
    if (jkLib.compareObject(currentItem, value)) {
      return; // 物件內容相同，不觸發更新
    }
    this._item.set(value); // 只有在物件內容不同時才設定新值
    if (this.state === entityState.dsInsert) {
      //this.itemIndex = -1;  20250928 remark
    } else {
      if(this.isEmpty(this.oldItem)){
        this.oldItem = {};
      }
      jkLib.cloneField(this._item(), this.oldItem);
      if (this.onAfterScroll) {
        this.onAfterScroll(this._item(), this.ret);
      }
      //let n = this.findIndexByKey(value);
      //if(n !== this.itemIndex){
      //  this.itemIndex = n;
      //}
    }
  }
  seqField: string = '';
  seqFieldLength: number = 4;
  loadBodyOpt: loadBodyOption;
  _state = signal<entityState>(entityState.dsBrowse);
  get stateName(): string {
    return entityStateName(this._state());
  }
  public get state(): entityState {
    return this._state();
  }
  public set state(value: entityState) {
    this.oldState = this._state();
    this._state.set(value);
    if (this.cbStateChanged) {
      this.cbStateChanged(this.state);
    }
  }
  isEditing(): boolean {
    return this.state === entityState.dsEdit;
  }
  isInserting(): boolean {
    return this.state === entityState.dsInsert;
  }
  isBrowsing(): boolean {
    return this.state === entityState.dsBrowse;
  }
  oldState: entityState = entityState.dsBrowse;
  public entityType: JkEntityType = new JkEntityType();
  public oldFlag: number = 0;
  public oldItem: any;
  validate: validateClass = new validateClass();
  //public lookup: any = {};
  public defaultItem: any; // 在 xxxxxService new Mtrwd() 產生.
  //DefaultObject: any; // 預設值 在 xxxxxService 產生.常數不許改
  //defaultValues: Array<any> = [];

  //public connectionString: string;
  public mainSql = '';
  public sqlSelect = '';
  // 需要 AND 開頭
  public sqlWhere = '';
  // 需有 order by
  public sqlOrder = '';
  public sqlGroupBy = '';
  public sqlWhereDefault = ' WHERE 1=1 ';
  public sqlOrderDefault = '';

  public sqlInsert = '';
  public sqlUpdate = '';
  public tableName = '';
  public keyFields: string[] = [];

  key: any = {};
  public get host(): string {
    if (this.login) {
      return this.login.hostName;
    } else
      return '';
  }
  public url = '/db/table';
  public rememberFields: string[] = []; // ,分開
  public requiredFields: string[] = [];
  cboOrder: idNameItem[] = [];
  public columnLabel: any = {}; // 欄位名稱
  columnDefs: ColDef[] = [];
  sortFieldList: string = '';
  columnDefsVir: ColDef[] = []; // 虛擬欄位
  public fieldLengths: any = {};
  selectPath: string = '';
  urlParam: string = '';
  token: string = '';
  body: any;
  fieldList: any = {};
  //defaultData: any = {}; 用defaultItem
  public isSys: boolean = false;

  /**  狀態:browse ,insert,edit */
  //keyAry: string[]; 併入 keyFields
  linkKeyObj: any; // linkMaster KEY值
  linkMasterFields: string = ''; // TD001=TC001,TD002=TC002
  //field: any;
  fieldNames: string = '';

  //gotoItemIndex: number = -1;
  selectRow: any; //function,當選那列時.要預設那些值
  isReady = false;
  programId: string = '';
  pageKind: PageKind = PageKind.master;
  cbStateChanged!: (state: entityState) => void;
  cbUIPost?: (params?: any) => Promise<boolean>;
  cbUICancel?: (item: any) => boolean;

  onAfterCancel?: (item: any, ret: jkRestReturn) => void;
  onAfterClose?: (item: any, ret: jkRestReturn) => void;
  onAfterDelete?: (e: any, ret: jkRestReturn) => void;
  onAfterEdit?: (item: any, ret: jkRestReturn) => void;
  onAfterInsert?: (item: any, ret: jkRestReturn) => void;
  onAfterOpen?: (item: any, ret: jkRestReturn) => void;
  onAfterPost?: (item: any, ret: jkRestReturn) => Promise<void>;
  onAfterQuery?: (item: any, ret: jkRestReturn) => void;
  onAfterRefresh?: (item: any, ret: jkRestReturn) => void;
  onAfterScroll?: (item: any, ret: jkRestReturn) => void;

  onBeforeCancel?: (item: any, ret: jkRestReturn) => void;
  onBeforeClose?: (item: any, ret: jkRestReturn) => void;
  onBeforeDelete?: (e: any, ret: jkRestReturn) => void;
  onBeforeEdit?: (item: any, ret: jkRestReturn) => void;
  onBeforeInsert?: (item: any, ret: jkRestReturn) => void;
  onBeforeOpen?: (e: any, ret: jkRestReturn) => void;
  onBeforePost?: (e: any, ret: jkRestReturn) => void;
  onBeforeQuery?: (e: any, ret: jkRestReturn) => void;
  onBeforeRefresh?: (e: any, ret: jkRestReturn) => void;
  onBeforeScroll?: (e: any, ret: jkRestReturn) => void;

  onMakeFilterOpt?: (ret: jkRestReturn) => void;
  onGetUrlParam?: () => void;

  //makeFilterOptCallBack: () => void;
  //onModalEditOk?: (item: any) => void;
  onUICancelEdit?: (bool: boolean) => void;
  //onDismiss?: () => void;

  onUIRefresh?: () => void;
  //onUIQuery?: (ds: JkEntityV2) => void;
  //onUIInsert?: (ds: JkEntityV2) => void;
  //onUIEdit?: (ds: JkEntityV2) => void;
  //onUIDelete?: (ds: JkEntityV2) => void;

  focusedRowKey: number = 0;
  // rowIndex: number = -1; //顯示的第幾列
  //oldItemIndex = -1; // 上一次的列 20250928 remark
  //_itemIndex = -1; // itemList 的 index 20250928 remark
  /* set itemIndex(value: number) { 20250928 remark
    this._itemIndex = value;
    if(this.oldItemIndex !== this._itemIndex){
      this.oldItemIndex = this._itemIndex;
      if(this.onAfterScroll){
        this.onAfterScroll(this.item,this.ret);
      }
    }
  }
  get itemIndex(): number {
    return this._itemIndex;
  }*/

  ret: jkRestReturn;

  constructor() {
    super();
    this.login = login;
    this.fieldList = {};
    this.loadBodyOpt = new loadBodyOption();
    this.ret = new jkRestReturnClass();
    computed(() => {
      this.itemList
    });

    this.init();
  }
  init() {//TODO: 反正都在constructor 跑. 考慮作廢
    // 接腳
  }
  afterContructor() {
  }
  initLinkKeyObj(linkKeyObj: any) {
    if (linkKeyObj) {
      jkLib.cloneField(linkKeyObj, this.linkKeyObj);
    }
  }
  get sysdbname(): string {
    if (!this.login.sysdbname) {
      alert('系統參數sysdbname 未設定,請聯絡管理員(companyList ps2 第二參數)');
    }
    return this.login.sysdbname;
  }
  get dbname(): string {
    if (!this.login.dbname) {
      alert('系統參數dbname 未設定,請聯絡管理員');
    }
    return this.login.dbname;
  }
  get userId(): string {
    return this.login.userid;
    //return User.UserID;
  }
  copyToClone() {
    this.cloneList = [];
    //this.cloneList.push(...this.itemList);
    this.itemList().forEach((p) => {
      let q = {};
      jkLib.cloneObject(p, q);
      this.cloneList.push(q);
    });
  }
  getKeyValues(values: any): any {
    let r = {};
    /*if(!values){
      throw new Error('getKeyValues values is null');
    }
    for (let i = 0; i < this.keyFields.length; i++) {
      (r as any)[this.keyFields[i]] = values[this.keyFields[i]];
    }*/
    return jkLib.getKeyValues2(values, this.keyFields);
  }
  async beforeInsert(item: any) {
    this.defaultManagerField(item, true);
    if (this.linkKeyObj) {// 有連結主檔 key 值設定主檔 key 值
      jkLib.cloneField(this.linkKeyObj, item);
    }
    if (this.onBeforeInsert) {
      await this.onBeforeInsert(item, this.ret);
    }
  }
  async afterInsert(item: any) {
    if (this.onAfterInsert) {
      await this.onAfterInsert(item, this.ret);
    }
  }
  async beforeEdit(item: any) {
    this.defaultManagerField(item, false);
    if (this.onBeforeEdit) {
      await this.onBeforeEdit(item, this.ret);
    }
  }
  FindMaxSeq(): string {
    let result = '';
    let ms1 = '';
    let i = 0;
    if (this.seqField === '') {
      alert('序號欄位代號未設定!');
      return '';
    }
    let dataList: number[] = [];
    this.itemList().forEach((p) => {
      let n = Number(p[this.seqField]);
      dataList.push(n);
    });
    let x = 0;
    if (dataList.length > 0) {
      x = Math.max(...dataList);
    }
    result = jkLib.zeroAtFirst(x + 1, this.seqFieldLength);
    return result;
  }
  getKeyFields(): string {
    let s: string = '';
    for (let i = 0; i < this.keyFields.length; i++) {
      s = s + jkLib.iif(s === '', '', ',') + this.keyFields[i];
    }

    return s;
  }
  checkRequiredFields(values: any, ret: jkRestReturn): boolean {
    // TODO:
    ret.clear(true);
    let ary = this.requiredFields; //.split(',');
    let type: string;
    let tmp: any;
    try {
      for (let i = 0; i < ary.length; i++) {
        tmp = values[ary[i]];
        if (typeof values[ary[i]] === 'undefined') {
          ret.message = '欄位不可空白:' + (this.columnLabel as any)[ary[i]];
          ret.result = false;
          break;
        }
        if (typeof values[ary[i]] == 'string') {
          if (values[ary[i]] === '') {
            ret.message = '欄位不可空白:' + (this.columnLabel as any)[ary[i]];
            ret.result = false;
            break;
          }
        }
        if (typeof values[ary[i]] == 'number') {
          if (values[ary[i]] === 0) {
            ret.message = '欄位不可空白:' + (this.columnLabel as any)[ary[i]];
            ret.result = false;
            break;
          }
        }
      }
      if (!ret.result) {
        alert(ret.message);
      }
      return ret.result;
      /*
        if(typeof tmp === 'string'){
          let s = jkLib.fixString(tmp).trim();
          if(s===''){
            let fn = this.columnLabel[ary[i]];
            ret.addResultError('欄位'+fn+' 不可空白');
            return false;
          }
        }else
        if(typeof tmp === 'number'){

        }
      }*/
    } catch (error: any) {
      this.jkRet.addResultError(error.message);
    }
    return ret.result;
  }
  SetRememberFields(oldValues: any, newValues: any): boolean {
    let b = true;
    let ary = this.rememberFields;
    try {
      for (let i = 0; i < ary.length; i++) {
        newValues[ary[i]] = oldValues[ary[i]];
      }
    } catch (error: any) {
      this.jkRet.addResultError(error.message);
      b = false;
    }
    return b;
  }
  getDefaultItem(): any {
    // 接腳到最子孫 才 new entity ex: new Jckma
    let r = {};
    //this.defaultManagerField(r, true);
    //if(this.state === entityState.dsInsert){  dsEdit 也要
    //this.beforeInsert(r);  // jackie 20240427 remark
    /*if (this.DefaultObject) {
      jkLib.cloneObject(this.DefaultObject, r);
    } else {
      //r = this.getDefaultItem();
      let msg = '程式錯誤:' + this.tableName + '.service DefaultObject 未設定';
      alert(msg, 'error');
    }*/
    if (this.defaultItem) {
      //jkLib.cloneObject(this.defaultItem, r);
      Object.assign(r, this.defaultItem);
    } else {
      //r = this.getDefaultItem();
      let msg = '程式錯誤:' + this.tableName + '.service defaultItem 未設定';
      alert(msg);
    }
    //}
    //this.beforeInsert(r); // newRecord 之後也跑一次
    return r;
  }
  async doUIOk(params?: any): Promise<boolean> {
    return await this.doUIPost(params);
  }
  async doUIPost(params?: any): Promise<boolean> {
    let bool = false; // TODO:
    if (this.cbUIPost) {
      bool = await this.cbUIPost(params);
    } else {
      alert('jkEntityV2 doUIPost 未設定 cbUIPost');
    }
    return bool;
  }
  doUICancel(item?: any): boolean {
    let bool = false; // TODO:
    bool = this.doCancel();
    if (this.cbUICancel) {
      bool = this.cbUICancel(item);
    }
    return bool;
  }
  doCancel(): boolean {
    if (this.onBeforeCancel) {
      this.onBeforeCancel(this.item, this.ret);
    }
    jkLib.cloneField(this.oldItem, this.item);
    this.state = entityState.dsBrowse;
    if (this.onAfterCancel) {
      this.onAfterCancel(this.item, this.ret);
    }
    return true;
  }
  //doInsert(defaultObj?: any): any {
  async doInsert(): Promise<any> {
    this.state = entityState.dsInsert;
    if(!this.oldItem){
      this.oldItem = {};
      jkLib.cloneField(this.defaultItem, this.oldItem);
    }
    jkLib.cloneField(this.item, this.oldItem);
    let defaultValue = this.getDefaultItem();
    this.item = defaultValue;
    await this.newRecord(this.item);
    //this.beforeInsert(this.item); // TODO: 與 getDefaultItem 重複 beforeInsert
    /*if (defaultObj) {  // jackie 20240427 remark
      jkLib.cloneObject(defaultObj, this.item);
    }*/
    return this.item;
  }
  async newRecord(newItem: any): Promise<any> {
    if((this.linkMasterFields!=='') && !(this.linkKeyObj)){
      const err_msg = '程式錯誤: linkMasterFields 設定為 ' + this.linkMasterFields + ' 但 linkKeyObj 未設定';
      alert('程式錯誤: 請先選單頭資料(linkKeyObj 未設定)');
      this.doUICancel();
      throw new Error(err_msg);
    }
    this.state = entityState.dsInsert;
    await this.beforeInsert(newItem);
    this.defaultRememberFields(newItem, this.oldItem);
    await this.afterInsert(newItem);
    return newItem;
  }
  async defaultRememberFields(newItem: any, oldItem: any) {
    let fn: string;
    let data: any;
    for (let i = 0; i < this.rememberFields.length; i++) {
      fn = this.rememberFields[i];
      if (!oldItem) {
        return;
      }
      try {
        data = oldItem[this.rememberFields[i]];
        if (data) {
          newItem[this.rememberFields[i]] = data;
        }
      } catch (error: any) { }
    }
  }
  defaultManagerField(table: any, isInsert: boolean) {
    try {
      if (isInsert) {
        table.COMPANY = this.dbname.substring(0, 9);
        table.CREATOR = this.userId;
        table.CREATE_DATE = jkLib.nowDate();
        table.USR_GROUP = '';
        table.MODIFIER = '';
        table.MODI_DATE = '';
        table.FLAG = 1;
      } else {
        table.MODI_DATE = jkLib.nowDate();
        if (table.FLAG) {
          table.FLAG = (table.FLAG + 1) % 999;
        } else {
          table.FLAG = 2;
        }
        table.MODIFIER = this.userId;
      }
    } catch (error: any) { }
  }
  postValidate(data: any): boolean {
    // 存檔前檢查
    this.jkRet.clear(true);

    return true;
  }
  //insert() {}
  //update() {}
  makeSql(): string {
    if (this.sqlOrder === '') {
      this.sqlOrder = this.sqlOrderDefault;
    }
    let sql =
      this.sqlSelect +
      jkLib.CR +
      this.sqlWhereDefault +
      this.sqlWhere +
      CR +
      this.sqlGroupBy +
      CR +
      this.sqlOrder;
    sql = jkLib.prepareSQL(sql, [], this.login.sysdbname, this.login.dbname);
    return sql;
  }
  makeSqlDelete(keyObj: any, keyCount: number): string {
    let mSQL = '';
    let keyFlds: string[] = [];
    for (let i = 0; i < keyCount; i++) {
      keyFlds.push(this.keyFields[i]);
    }
    if (this.isSys) {
      mSQL =
        'DELETE ' +
        this.sysdbname +
        '..' +
        this.tableName +
        //' AS ' +  this.tableName +
        ' WHERE 1=1 ';
    } else {
      mSQL = 'DELETE ' + this.tableName + ' WHERE 1=1 ';
    }
    //debugger;
    for (let i = 0; i < keyCount; i++) {
      let value = keyObj[keyFlds[i].trim()];
      if (value === undefined) {
        throw new Error('keyObj[' + keyFlds[i] + '] is undefined');
      }
      mSQL = mSQL + ' AND ' + keyFlds[i] + '=' + jkLib.quotedStr(value);
    }
    return mSQL;
  }

  /*
  async getByKey(keyValues: any[]): Promise<any[]> {
    // TODO:
    const ds =  this.jkBDb.doFetch(this.host, this.selectPath, this.urlParam, this.token,'post', this.body);
    return this.items;
  }*/
  // #goodjob!
  findIndexByKey_old(keyValues: any): number {
    let i = 0;
    let found = false;
    let keyCount = this.keyFields.length;
    while (i < this.itemList().length && !found) {
      found = true;
      for (let j = 0; j < keyCount; j++) {
        if (
          this.itemList()[i][this.keyFields[j]] !== keyValues[this.keyFields[j]]
        ) {
          found = false;
          break;
        }
      }
      if (!found) {
        i++;
      }
    } //while
    if (found) {
      return i;
    } else {
      return -1;
    }
  }
  // gpt-4
  findIndexByKey2(keyValues: any): number {
    const keyCount = this.keyFields.length;
    for (let i = 0; i < this.itemList().length; i++) {
      let found = true;
      for (let j = 0; j < keyCount; j++) {
        if (this.itemList()[i][this.keyFields[j]] !== keyValues[this.keyFields[j]]) {
          found = false;
          break;
        }
      }
      if (found) {
        return i;
      }
    }
    return -1;
  }
  // copilot
  findIndexByKey(keyValues: any): number {
    return this.itemList().findIndex(item =>
      this.keyFields.every(keyField => item[keyField] === keyValues[keyField])
    );
  }
  //readerQuery() {}
  //deleteOne(values: any[]) {}
  keyCount(): number {
    return this.keyFields.length;
  }
  buildQuery(xWhere: string, xOrder: string): string {
    let sql = '';
    let where: string;
    let order: string;
    if (!xOrder) {
      order = this.sqlOrder;
    } else {
      order = xOrder;
    }
    if (!xWhere) {
      where = this.sqlWhere;
    } else {
      where = xWhere;
    }
    sql = this.sqlSelect + ' ' + where + ' ' + order;
    return sql;
  }
  field2Date(o: string, f: string) {
    //debugger;
    if (o) {
      const d = new Date(
        parseInt(o.substring(0, 4), 10),
        parseInt(o.substring(4, 2), 10) - 1,
        parseInt(o.substr(6, 2), 10),
        0,
        0,
        0,
        0
      );
      (this as any)[f] = d;
    } else {
      (this as any)[f] = new Date('');
      (this as any)[f] = undefined;
    }
  }
  field2Boolean(o: string, f: string) {
    if (o === 'Y') {
      (this as any)[f] = true;
    } else {
      (this as any)[f] = false;
    }
  }

  date2Field(data: Date, f: string) {
    (this as any)[f] = jkLib.date2DateField(data);
  }
  boolean2Field(b: boolean, fieldName: string) {
    if (b) {
      (this as any)[fieldName] = 'Y';
    } else {
      (this as any)[fieldName] = 'N';
    }
  }

  billDate(item: any, xDate?: string): string {
    if (xDate === undefined) {
      if (this.entityType.billDateFieldName !== '') {
        return item[this.entityType.billDateFieldName]();
      } else {
        return '';
      }
    } else {
      item[this.entityType.billDateFieldName] = xDate;
      return item[this.entityType.billDateFieldName];
    }
  }
  /*
  getField(xFieldName: string): any { return this.item[xFieldName]; };
  setField(xFieldName: string, xValue: any): boolean {
    try {
      this.item[xFieldName](xValue);
    }
    catch (e: any) {
      alert(e.message, 'getfield error:' + xFieldName);
      return false;
    };
    return true;
  };*/
  /*
    rowData2Field(xData: any): boolean {
      if (xData === undefined) { return false; };
      if (this.fieldNames === undefined) { return false; };

      let mRet = true;
      const ary = this.fieldNames.split(',');
      for (let i = 0; i < ary.length; i++) {
        try {
          this.field[ary[i].trim()](xData[ary[i].trim()]);
        } catch (e: any) {
          mRet = false;
          //alert(ary[i]+"this.field找不到欄位",e.message);
        };
      };
      return mRet;
    };*/
  /*
  editingStart(): void {
    this.oldFlag = this.item['FLAG']();
    this.item['FLAG'](this.item['FLAG']() + 1);
    this.item['MODI_DATE'](this.nowDate());
    this.item['MODIFIER'](User.UserID);
  };*/
  /*
  field2RowData(): any {
    // debugger;
    const mRowData = {};
    const ary = this.fieldNames.split(',');
    for (let i = 0; i < ary.length; i++) {
      try {
        mRowData[ary[i].trim()] = this.field[ary[i].trim()]();
      } catch (e: any) {
        alert('this.field找不到欄位' + ary[i], e.message);
        return {};
      };
    };
    return mRowData;
  };
  */

  /*
  getKeyValues(xIsSql: boolean): string {
    let mKey = '';
    const ary = this.keyFields.split(',');
    // debugger;
    if (xIsSql) {
      for (let i = 0; i < ary.length; i++) {
        mKey = mKey + ' AND ' + ary[i] + '=' + jkLib.quotedStr(this.getField(ary[i].trim()));
      };
    } else {
      for (let i = 0; i < ary.length; i++) {
        if (i === 0) {
          mKey = this.getField(ary[i].trim());
        } else {
          mKey = mKey + '||' + this.getField(ary[i].trim());
        };
      };
    };
    return mKey;
  };
  */
  // ui2RowData: any;
  cloneEntityField(item: any): any {
    let r: any = {};
    const ary = this.fieldNames.split(',');
    for (let i = 0; i < ary.length; i++) {
      r[ary[i].trim()] = item[ary[i].trim()];
    };
    return r;
  }
  async validateItem(item: any): Promise<boolean> {
    return true;
    // 留接腳給子孫
    //let data = item as T;
    //const cloneItem = this.cloneEntityField(item); // ^_^ jackie 20250801 add
    const cloneItem = this.getDefaultItem();
    Object.keys(cloneItem).forEach((element) => {
      (cloneItem as any)[element] = (item as any)[element];
    });

    //let v = await validate(item);
    let v = await validate(cloneItem);  // FIXME: ^_^ jackie 20250801 modi cloneItem 沒有 validate 裝飾
    if (v.length > 0) {
      let msg = '';
      for (let i = 0; i < v.length; i++) {
        msg = msg + JSON.stringify(v[i].constraints) + CR;
      }
      jkAlert(msg, 'error');
      throw new Error(msg);
      // return false;
    }
    return true;
  }
  checkValidate(ret: jkRestReturn): boolean {
    let r = '';
    ret.clear(true);
    if (!this.validate.isAllValid()) {
      r = this.validate.AllMessage();
      ret.addResultError(r);
      alert(r);
    }
    return ret.result;
  }
  async doBeforePost(item: any, ret: jkRestReturn): Promise<boolean> {
    ret.clear(true);
    // 留接腳給子孫
    if (!item) {
      item = this.item;
    }

    let result = true;
    this.checkNull(item); // 檢查空值 用 DefaultObject 預設值
    if (!this.checkValidate(ret)) {
      return false;
    }
    // 有錯就直接 raise error ?
    result = this.postValidate(item);
    // TODO: 應該UI 按 OK 前就檢查過了
    result = await this.validateItem(item);

    if (result && this.onBeforePost) {
      this.onBeforePost(item, this.ret);
    }

    return ret.result;
  }

  /**
   * 舊的doMyOk
   *
   * @param {*} item
   * @param {jkRestReturn} mReturn
   * @return {*}  {Promise<boolean>}
   */
  async doMyOkV0(item: any, mReturn: jkRestReturn): Promise<boolean> {
    try {
      mReturn.clear();
    } catch (e: any) {
      jkAlert(e.message, 'doMyOk error');
    }
    if (!this.checkRequiredFields(item, mReturn)) {
      return false;
    }
    // if (this.state === "edit") { this.editingStart(); };
    //item = this.item2item();
    let beforeBool = await this.doBeforePost(item, mReturn);
    if (!beforeBool) {
      return false;
    }
    if (this.state === entityState.dsInsert) {
      let mRet: jkRestReturn = new jkRestReturnClass();
      // TODO: 改 entityCrud ?
      mRet = await this.insertTable(
        item,
        this.entityType.type,
        this.getKeyValues(item),
        this.billDate(item)
      );
      // debugger;
      mReturn.data = mRet.data;
      mReturn.message = mRet.message;
      mReturn.result = mRet.result;
      mReturn.rowsAffected = mRet.rowsAffected;

      if (mReturn.result === false) {
        jkAlert('新增存檔失敗!!!' + mReturn.message, '');
      } else {
        // this.doMyBack(xView,xRoot);
      }
      return mReturn.result;
    }
    if (this.state === entityState.dsEdit) {
      //const mNewData = JSON.stringify(this.item);
      //let mKeyValues = this.item["TE001"] + "||" + this.item["TE002"] + "||" + this.item["TE003"];
      // debugger;
      mReturn = await this.updateTable(item, this.getKeyValues(item));
      if (mReturn.result) {
        // doMyBack();
      } else {
        jkAlert('修改存檔失敗!!!' + mReturn.message, '');
      }

      return mReturn.result;
    }
    if (this.state === entityState.dsBrowse) {
      jkAlert('XXX 存檔時是瀏覽狀態 (browse)!!!', '');
    }

    return mReturn.result;
  }

  async doRefresh() {
    await this.loadData();
  }
  /*async doMyQuery() {
    //this.doUIRefresh();
  }*/

  async refreshList(): Promise<void> {
    //if (this.listSet) {
    this.makeSql();
    //this.getTable();
    await this.loadData();

    //this.doUIRefresh();
    if (this.itemList().length > 0) {
      // this.getList().selectItem([0]); ??? 如何預設第一筆
    }
  }
  /*
  async getTable() {
    const mReturn: jkRestReturn = await  this.jkBDb.simpleSql(this.mainSql);
    if (!mReturn.result) {
      jkAlert(mReturn.message, 'mainSql 取資料錯誤');
    } else {
      this.itemList = mReturn.obj;
    }
    return this.itemList; // getMasterTable,
  };
  */

  async insertTable(
    xData: any,
    type: EntityType,
    xkeyValues: string,
    xdate: string
  ): Promise<any> {
    const body = JSON.parse(xData);
    const urlParam =
      'table=' +
      this.tableName +
      '&type=' +
      type +
      '&keyFields=' +
      this.getKeyFields() +
      '&keyValues=' +
      xkeyValues +
      '&date=' +
      xdate;

    const mReturn = await jkLib.doFetch(
      this.login.hostName,
      '/db/insert',
      urlParam,
      this.login.token,
      'post',
      body
    );

    return mReturn;
  }

  async batchDeleteByKeyValue(info: any): Promise<jkRestReturn> {
    //let mReturn: jkRestReturn; //= new jkRestReturnClass();
    let mSQL = '';
    mSQL = 'DELETE ' + this.iif(this.isSys, '##', '') + this.tableName + ' WHERE 1=1 ';// TODO:系統資料庫加## ?
    //debugger;
    for (let i = 0; i < this.keyFields.length; i++) {
      mSQL =
        mSQL +
        ' AND ' +
        this.keyFields[i] +
        '=' +
        jkLib.quotedStr(info.key[this.keyFields[i].trim()]);
    }

    const mReturn = await this.orm.transactionOneSql(mSQL);
    if (mReturn.result) {
      // sumTotal();
    } else {
      jkAlert('刪除失敗!!!' + mReturn.message, '');
    }

    return mReturn;
  }
  /**
   * 訊息盡量做在 page 那一層
   * @param rowData
   * @param isAsk
   * @returns
   */
  async doDelete(rowData?: any, isAsk: boolean = true, isDeleteItemList: boolean = true): Promise<jkRestReturn> {
    let index = 0;
    let ret: jkRestReturn = new jkRestReturnClass();
    if (!rowData) { // jackie 20240418 add
      rowData = this.item;
    }
    if (isAsk) {
      if (!confirm('確定要刪除嗎?')) {
        return ret;
      }
    }
    if (!rowData) {
      jkAlert('請選擇要刪除的資料');
      return ret;
    }
    if (this.isBatchMode) {
      this.batchDeleteByKeyValue(rowData);
    } else {
      let keyObj = this.getKeyValues(rowData);
      if (keyObj) {
        index = this.findIndexByKey(keyObj);
        let flag = rowData.FLAG;
        ret = await this.deleteByKeyValue(keyObj, flag);
        if (!ret.result) {
          jkAlert(ret.getResultError());
        } else {
          if (isDeleteItemList) {
            const currentList = [...this.itemList()];
            currentList.splice(index, 1);
            this.setItemList(currentList);
          }
        }
      } else {
        jkAlert('請選擇要刪除的資料');
      }
    }
    return ret;
    /*
    if(ndx){
      this.rowIndex = ndx;
    }
    if(this.rowIndex < 0){
      jkAlert('請選擇要刪除的資料');
      return;
    }
    await this.deleteByItem(this.itemList()[this.rowIndex]);
    */
  }
  async deleteByItem(item: any): Promise<jkRestReturn> {
    let key = this.getKeyValues(item);
    return this.deleteByKeyValue(key, item.FLAG);
  }
  deleteItemOnly(keyObj: any, keyFields: string[]): any {
    let ndx = this.itemList().findIndex((item: any) => {
      for (let i = 0; i < keyFields.length; i++) {
        if (item[keyFields[i]] !== keyObj[keyFields[i]]) {
          return false;
        }
      }
      return true;
    });
    const currentList = [...this.itemList()];
    currentList.splice(ndx, 1);
    this.setItemList(currentList);
    if (ndx > this.itemList().length - 1) {
      ndx = this.itemList().length - 1;
    }
    if (ndx >= 0) {
      this.item = this.itemList()[ndx];
    } else {
      jkLib.cloneField(this.defaultItem, this.item);
    }
    return this.item;
  }

  async deleteByKeyValue(keyValue: any, flag: number): Promise<jkRestReturn> {
    //let mReturn: jkRestReturn = new jkRestReturnClass();
    let mSQL = '';
    if (this.isSys) {
      mSQL = 'DELETE ' + this.sysdbname + '..' + this.tableName + ' WHERE 1=1 ';
      //mSQL = 'DELETE ##' + this.tableName + ' WHERE 1=1 '; transactionsql 不支援 ##
    } else
      mSQL = 'DELETE ' + this.tableName + ' WHERE 1=1 ';
    //if(flag)
    //  mSQL = mSQL + ' AND FLAG=' + flag;
    //debugger;
    mSQL = this.dsObject2Where(keyValue, mSQL);

    const mReturn = await this.orm.transactionOneSql(mSQL);
    if (mReturn.result) {
      // sumTotal();
    } else {
      jkAlert('刪除失敗!!!' + mReturn.message, '');
    }

    return mReturn;
  }
  info2Data(info: any): boolean {
    let keyValues = '';
    const ary = this.keyFields;
    for (let i = 0; i < ary.length; i++) {
      if (keyValues === '') {
        keyValues = info.key[ary[i].trim()].trim();
      } else {
        keyValues = keyValues + '||' + info.key[ary[i].trim()].trim();
      }
    }
    return true;
  }
  async batchUpdateTable(info: any): Promise<jkRestReturn> {
    let mReturn: jkRestReturn = new jkRestReturnClass();
    //debugger;
    // 這段改成 myTable.batchUpdateTable()
    // batch mode 在這裡改
    this.oldFlag = info.key.FLAG;
    info.key.FLAG = info.key.FLAG + 1;
    info.key.MODI_DATE = jkLib.nowDate();
    info.key.MODIFIER = this.login.UserID;

    const mNewData = this.jkBDb.updateData(info);

    //let mKeyValues = info.key.WD001 + '||' + info.key.WD002 + '||' + info.key.WD003;
    const mKeyValues =
      info.key[this.keyFields[0]] +
      '||' +
      info.key[this.keyFields[1]] +
      '||' +
      info.key[this.keyFields[2]];
    mReturn = await this.updateTable(mNewData, mKeyValues);

    return mReturn;
  }
  async updateTable(xData: string, xKeyValues: string): Promise<jkRestReturn> {
    const urlParam =
      'table=' +
      this.tableName +
      '&oldflag=' +
      this.oldFlag +
      '&keyFields=' +
      this.getKeyFields() +
      '&keyValues=' +
      xKeyValues;
    const body = JSON.parse(xData);
    const mReturn = await jkLib.doFetch(
      this.login.hostName,
      '/update',
      urlParam,
      this.login.token,
      'post',
      body
    );
    return mReturn;
  }
  setEditState(xIndex: number): boolean {
    // debugger;
    let mRet = true;
    this.state = entityState.dsEdit;
    //this.itemIndex = xIndex; 20250928 remark
    //mRet = this.rowData2Field(this.itemList()[xIndex]);
    //this.editingStart();
    /*     {
            mRet = false;
            jkAlert("getTable 取得筆數不對:" + this.mainSql, "無法進入修改狀態!!!");
        };*/
    return mRet;
  }
  async initFromOpenwin(
    // 改用 catchopenwin
    type: string,
    maintable: string,
    item: string
  ): Promise<boolean> {
    this.isOpenWin = true;
    let sqlSelect =
      ' select * FROM ##OpenWin ' +
      ' WHERE MainTable=' +
      jkLib.quotedStr(maintable) +
      ' AND ITEM=' +
      jkLib.quotedStr(item) +
      ' AND TYPE=' +
      jkLib.quotedStr(type);
    let mReturn = await this.jkBDb.simpleSqlJkRestReturn(sqlSelect);
    try {
      let ret = mReturn.obj[0];
      this.sqlSelect = jkLib.fixString(ret.SQLSelect);
      this.sqlOrder = jkLib.fixString(ret.SQLOrder);
      this.sqlWhereDefault = jkLib.fixString(ret.SQLWhere);
      //this.sqlSelect = mReturn[0].SQLSelect;
      //this.cboOrder = mReturn.obj.SQLOrder;
      //this.sqlWhereDefault = mReturn.obj.SQLWhere;
    } catch (error: any) {
      jkAlert('initFromOpenwin error:' + error.message);
      return false;
    }
    return true;
  }
  makeFilterOpt(): boolean {
    let result = false;
    if (this.onMakeFilterOpt) {
      this.onMakeFilterOpt(this.ret);
      result = true;
    }
    return result;
  }
  getUrlParam() {
    if (this.onGetUrlParam) {
      this.onGetUrlParam();
    }
  }
  async query(where: string, order: string): Promise<any> {
    const token = this.getToken(where.trim().toUpperCase(),' ',1);
    if (token !=='AND'){
      alert(' query() where 條件必須以 AND 開頭');
      throw new Error(' query() where 條件必須以 AND 開頭');
    }
    const orderStr = this.getToken(order.trim().toUpperCase(),' ',1);
    if (orderStr !=='ORDER'){
      alert(' query() order 條件必須以 ORDER 開頭');
      throw new Error(' query() order 條件必須以 ORDER 開頭');
    }
    this.sqlWhere = where;
    this.sqlOrder = order;
    return await this.loadData();
  }
  async loadData(): Promise<any> {
    //if(where === ''){ this.sqlWhere = this.sqlWhereDefault; }else{ this.sqlWhere = where;};
    //this.sqlWhere = where;
    //if(order === ''){ this.sqlOrder = this.sqlOrderDefault; }else{ this.sqlOrder = order;};
    //let loadBody: loadBodyOption = new loadBodyOption();
    /*
    if (!this.loadBodyOpt.tableName) {
      jkAlert('程式錯誤:entity 還沒跑init()');
    }
    //this.loadBodyOpt.key = this.keyFields;
    this.loadBodyOpt.method = 'get';
    let bool = this.makeFilterOpt();
    if(!bool){
      if(this.entityType.type === EntityType.master){
        this.itemList() = [];
        return this.itemList();
      }
    }
    this.loadBodyOpt.sql = this.makeSql();
    */
    let bool = this.initBodyOpt('get', this.makeSql());
    if (!bool) {
      if (this.entityType.type === EntityType.master) {
        this.setItemList([]);
      }
    } else {
      /*   // jackie 20240813 remark
      this.loadByHttpClient(this.sqlWhere,this.sqlOrder).subscribe({
        next: (value) => {
          // 處理正常的值
          this.itemList() = value.obj;
        },
        error: (error) => {
          // 處理錯誤
          jkAlert(this.tableName + ' 載入錯誤:' + error.message);
          this.itemList() = []; // FIXME: 要清空資料?
      },
        complete: () => {
          // 完成時執行（可選）
        }
      });
      */
    }

    this.getUrlParam();
    try {
      // this.itemList = await  this.jkBDb.sendRequest(
      this.setItemList(await this.jkBDb.sendRequest(
        this.host,
        this.url,
        this.urlParam,
        'POST',
        this.jkRet,
        this.loadBodyOpt
      ));
      if (this.jkRet.result === false) {
        jkAlert(this.tableName + ' 載入錯誤:' + this.jkRet.errorLog);
        this.setItemList([]);
      }
    } catch (error: any) {
      jkAlert(this.tableName + ' 載入錯誤:' + error.message);
    }
    return this.itemList();
  }
  /* where: string, 空白或 AND 開頭
  */
  loadByHttpClient(where: string, order: string): Observable<any> {
    this.sqlWhere = where;
    this.sqlOrder = order;
    let bool = this.initBodyOpt('get', this.makeSql());
    if (!bool) {
      if (this.entityType.type === EntityType.master) {
        this.setItemList([]);
      }
    }
    this.getUrlParam();

    return this.orm.http.post(this.host + this.url, this.loadBodyOpt);
  }
  initBodyOpt(method: string, sql: string) {
    this.loadBodyOpt.tableName = this.tableName;
    this.loadBodyOpt.isSys = this.isSys;
    if (!this.loadBodyOpt.tableName) {
      jkAlert('程式錯誤:entity 還沒跑init()');
    }
    //this.loadBodyOpt.key = this.keyFields;
    this.loadBodyOpt.method = method;
    this.loadBodyOpt.sql = sql;
    return this.makeFilterOpt();
  }
  /*
  async removeData(key: any) {
    //let loadBody: loadBodyOption = new loadBodyOption();
    //loadBody.isSys = this.isSys;
    //loadBody.key = this.keyFields;
    this.loadBodyOpt.method = 'DELETE';
    //loadBody.sql = this.makeSql();
    //loadBody.tableName = this.tableName;
    //loadBody.values = {};
    //loadBody.where = key;
    this.loadBodyOpt.keyValues = key;
    //this.getUrlParam();
    //let param1 =  'tableName=' + this.tableName + '&isSys='+this.isSys.toString();
    let r = await this.jkBDb.sendRequest(
      this.host,
      this.url, // '/db/table';
      this.urlParam,
      'POST',
      this.jkRet,
      this.loadBodyOpt
    );
    if (this.jkRet.result === false) {
      jkAlert('qryMaster remove error:' + this.jkRet.errorLog);
    }
  }
  */
  /*async delete(key: any) {
    await this.removeData(key);
  }*/
  async insertData(
    values: any,
    isAddList: boolean,
    retValue: any
  ): Promise<boolean> {
    let postItem = this.filterVirtualFields(values);
    this.initBodyOpt('INSERT', '');
    this.loadBodyOpt.key = this.keyFields;
    //this.loadBodyOpt.method = 'INSERT';
    this.loadBodyOpt.values = postItem;
    this.loadBodyOpt.keyValues = this.getKeyValues(postItem);
    this.loadBodyOpt.where = this.sqlWhere;
    this.getUrlParam();
    //let param1 =  'tableName=' + this.qryMaster.tableName + '&isSys='+this.qryMaster.isSys.toString();
    retValue = await this.jkBDb.sendRequest(
      this.host,
      this.url,
      this.urlParam,
      'POST',
      this.jkRet,
      this.loadBodyOpt
    );
    if (this.jkRet.result === false) {
      jkAlert(this.tableName + ' insert error:' + this.jkRet.errorLog, 'error');
    }
    jkLib.cloneField(retValue, this.item);

    /*if (this.gridSet) {
      jkLib.cloneField(ds, this.gridSet.rowData);
    }*/
    if (isAddList) {
      //jkAlert('這裡要測試: insertData itemInsertByKey:' + JSON.stringify(ds));
      //this.itemInsertByKey(ds);
      this.pushItem(retValue); // ^_^ 20230507 TODO: 虛欄位會不見
    }
    return this.jkRet.result;
  }
  // * 20240405 remark 舊的
  async doMyOk(): Promise<boolean> {
    // save,update
    let mReturn: jkRestReturn = new jkRestReturnClass();
    mReturn.clear();
    if (!this.checkRequiredFields(this.item, mReturn)) {
      return false;
    }
    // if (this.state === "edit") { this.editingStart(); };
    //item = this.item2item();
    let beforeRet = await this.doBeforePost(this.item, mReturn);
    if (!beforeRet) {
      return false;
    }
    if (this.state === entityState.dsInsert) {
      let mRet: jkRestReturn = new jkRestReturnClass();
      if (this.isBatchMode) {
        // this.batchUpdateTable(this.item); // TODO: 這裡要測.改 billSrv ?
        await this.doMyAfterPost(this.item);
      } else {
        //if (this.entityType.type === EntityType.data) {
        if (true) {
          let retValue: any = undefined;
          let bool = await this.insertData(this.item, true, retValue);
          if (bool) {
            await this.doMyAfterPost(this.item);
          }
        } else {
          // TODO: 改 billSrv batchupdate ?
          mRet = await this.insertTable(
            this.item,
            this.entityType.type,
            this.getKeyValues(this.item),
            this.billDate(this.item)
          );
          // debugger;
          mReturn.data = mRet.data;
          mReturn.message = mRet.message;
          mReturn.result = mRet.result;
          mReturn.rowsAffected = mRet.rowsAffected;

          if (mReturn.result === false) {
            jkAlert('新增存檔失敗!!!' + mReturn.message, '');
          } else {
            // this.doMyBack(xView,xRoot);
          }
        }
      }
      //this.modalEditHide();
      if (this.onUICancelEdit) {
        this.state = entityState.dsBrowse; // ^_^ jackie 20250129 add
        this.onUICancelEdit(mReturn.result);
      }
      if (this.onAfterScroll) {
        this.state = entityState.dsBrowse; // ^_^ jackie 20250129 add
        this.onAfterScroll(this.item, this.ret);
      }

      return mReturn.result;
    }
    if (this.state === entityState.dsEdit) {
      let key = this.getKeyValues(this.item); //parent.masterGridSet.key
      let find = this.findIndexByKey(key);
      if (find < 0) {
        jkAlert('找不到資料');
        return false;
      } else {
        let tmpItem = this.itemList()[find];
        jkLib.cloneField(this.item, tmpItem);
        this.updateItem(find, tmpItem); // 虛欄位會不見
      }
    }
    if (this.isBatchMode) {
      // this.batchUpdateTable(this.item); // TODO: 這裡要測
    } else {
      // if (this.entityType.type === EntityType.data) {//TODO: 先不用 updateTable
      if (true) {//TODO: 先不用 updateTable
        mReturn = await this.updateData(this.getKeyValues(this.item), this.item);
      } else {
        //const mNewData = JSON.stringify(this.item);
        //let mKeyValues = this.item["TE001"] + "||" + this.item["TE002"] + "||" + this.item["TE003"];
        // debugger;
        mReturn = await this.updateTable(this.item, this.getKeyValues(this.item));
        if (mReturn.result) {
          // doMyBack();
        } else {
          jkAlert('修改存檔失敗!!!' + mReturn.message, '');
        }
        //this.modalEditHide();
        /*if(this.onUICancelEdit){
          this.onUICancelEdit(mReturn.result);
        }*/

        return mReturn.result;
      }
    }
    if (this.state === entityState.dsBrowse) {
      jkAlert('XXX 存檔時是瀏覽狀態 (browse)!!!', '');
    }
    //this.modalEditHide();
    if (this.onUICancelEdit) {
      this.onUICancelEdit(mReturn.result);
    }

    return mReturn.result;
  }

  checkNull(ds: any) {
    // TODO:
    Object.keys(ds).forEach((e) => {
      if (ds[e] === undefined || ds[e] === null) {
        ds[e] = this.defaultItem[e];  //this.DefaultObject[e];
      }
    });
  }
  item2ItemList(isInsert: boolean) {
    // TODO:
  }
  async updateData(key: string, values: any): Promise<jkRestReturn> {
    let updRet = new jkRestReturnClass();
    if (!key) {
      alert('updateData key is null');
      return updRet;
    }
    let postItem = this.filterVirtualFields(values);
    this.loadBodyOpt.key = this.keyFields;
    this.loadBodyOpt.keyValues = key; // this.qryMaster.getKeyValues(values);
    this.initBodyOpt('UPDATE', this.makeSql());
    //this.loadBodyOpt.method = 'UPDATE';
    //this.loadBodyOpt.sql = this.makeSql();
    this.loadBodyOpt.values = postItem;
    this.loadBodyOpt.where = key;
    this.getUrlParam();
    //let param1 =  'tableName=' + this.qryMaster.tableName + '&isSys='+this.qryMaster.isSys.toString();
    let r = await this.jkBDb.sendRequest(
      this.host,
      this.url,
      this.urlParam,
      'POST',
      updRet,
      this.loadBodyOpt
    );
    if (updRet.result === false) {
      alert(this.tableName + ' update error:' + updRet.errorLog);
    }
    return updRet;
  }



  doEdit(e?: any) {
    if (this.item) {
      jkLib.cloneField(this.item, this.oldItem);

      let keyObj = this.getKeyValues(this.item);
      //this.itemIndex = this.findIndexByKey(keyObj);  20250928 remark
      /*if (this.itemIndex >= 0) {
        this.cloneObject(this.itemList[this.itemIndex], this.item);
      } else {
        this.cloneObject(item, this.item);
      }*/
    }
    /*if (index === undefined) {
      index = this.rowIndex;
    };
    if (index >= 0) {
      this.state = entityState.dsEdit;
      jkLib.cloneField(this.itemList[index],this.item);
      this.defaultManagerField(this.item, false);

    }else{
      alert('請先選擇一筆資料');
    }*/
    this.state = entityState.dsEdit;
    this.defaultManagerField(this.item, false); //一律靠 item.少用 rowIndex
    this.beforeEdit(this.item);
  }
  async doMyAfterPost(item: any) {
    this.state = entityState.dsBrowse;
    jkLib.cloneField(item, this.oldItem);
    if (this.onAfterPost) {
      await this.onAfterPost(item, this.ret);
    }
  }

  /*row2column(item: any): any {
    return jkLib.row2column(item,this.columnLabel);
  }*/
  //==[for modal,去除 gridset]==========================
  filterVirtualFields(item: any): any {
    let postItem = this.getDefaultItem();
    //this.defaultManagerField(postItem, true); //補上管理欄位
    //this.defaultManagerField(postItem, false);

    Object.keys(postItem).forEach((key) => {
      //這段用來去掉虛欄位
      postItem[key] = item[key];
    });
    return postItem;
  }
  async editAndSave(item: any, isPrompt: boolean = true): Promise<boolean> {
    try {
      this.item = item;
      this.doEdit(); // ###
      let bool = await this.modalEditOk();
      if (!bool) {
        return false;
      }
      if (isPrompt) {
        alert('存檔OK.');
      }
      return true;
    } catch (error) {
      return false;
    }
  }
  async modalEditOk(e?: any): Promise<boolean> {
    return await this.doMyOk();
    /*let result = false;
    let postItem = this.item; // this.filterVirtualFields(this.item);
    let ret = new jkRestReturnClass();
    ret.ok();
    if (this.onBeforePost) {
      this.onBeforePost(postItem, ret);
    }

    if (this.state === entityState.dsInsert) {
      let retValue: any = undefined;
      let r = await this.insertData(postItem, true, retValue); // false or rowData
      if (!r) {
        alert('新增存檔失敗!!!' + ret.message, '');
        return false;
      }else{
      }
      this.itemList.push(postItem);// 這行要放在insertData後面 TODO: 可能是要push r 才對
      //this.gridSet.grid.instance.refresh();
      //if (this.onUIRefresh) {
      //  this.onUIRefresh();
      //}
    } else {
      let key = this.getKeyValues(postItem); //parent.masterGridSet.key
      let find = this.findIndexByKey(key);
      if (find < 0) {
        alert('找不到資料');
        return false;
      } else {
        jkLib.cloneField(postItem, this.itemList[find]);
      }
      let r = await this.updateData(key, postItem); // false or rowData
    }


    this.modalEditHide();
    result = true;
    return result;
    */
  }
  /*
  modalEditHide() {
    if (this.state === entityState.dsInsert) {
      //this.gridSet.grid.instance.cancelEditData();
      if (this.onUICancelEdit) {
        this.onUICancelEdit();
      }
    }
    this.state = entityState.dsBrowse;
  }
  modalEditCancel() {
    this.modalEditHide();
  }
  */

  textAreaChange(e: any) {
    let id = e.element.id;
    if (!id) {
      alert('程式錯誤:元件未設定id');
      return;
    }
    //this.rowData[id] = e.value;
    this.item[id] = e.value; // 內文
  }
  async simpleSql(sql: string): Promise<jkRestReturn> {
    const mReturn: jkRestReturn = await this.jkBDb.simpleSql(sql);
    if (!mReturn.result) {
      jkAlert(mReturn.message, 'mainSql 取資料錯誤');
    }
    return mReturn;
  }
  /**
   *
   * @param xAry string or number array
   * @param xField
   * @returns
   */
  dsArray2Where(xAry: Array<any>, xField: string): boolean {
    let result = true;
    this.sqlWhere = jkLib.array2Where(xAry, this.sqlWhere, xField);
    return result;
  }
  dsText2Where(xText: string, xField: string, xOper: string): boolean {
    let result = true;
    this.sqlWhere = jkLib.text2Where(xText, this.sqlWhere, xField, xOper);
    return result;
  }
  dsObjectArray2Where(
    xRetField: string,
    xAry: Array<any>,
    xField: string
  ): boolean {
    let result = true;
    this.sqlWhere = jkLib.objectArray2Where(
      xRetField,
      xAry,
      this.sqlWhere,
      xField
    );
    return result;
  }
  dsObject2Where(xObj: any, xWhere: string): string {
    let result = xWhere;
    if (xObj) {
      Object.keys(xObj).forEach((key) => {
        if (xObj[key] !== undefined && xObj[key] !== null && xObj[key] !== '') {
          result = jkLib.text2Where(xObj[key], result, key, '=');
        }
      });
    }
    return result;
  }
  itemInsertByKey(item: any): boolean {
    // TODO:
    let result = true;
    let key = this.getKeyValues(item);
    let ndx = this.findIndexByKey(key);
    const currentList = [...this.itemList()];
    currentList.splice(ndx, 0, item);
    this.setItemList(currentList);
    return result;
  }
  swapMasterDetail(linkFields: string): string {
    let ary: string[] = linkFields.split(',');
    for (let i = 0; i < ary.length; i++) {
      let temp: string[] = ary[i].split('=');
      ary[i] = temp[1] + '=' + temp[0];
    }
    let linkParent = ary.join(',');
    return linkParent;
  }
  initLinkMaster(linkMasterFields: string) {
    this.linkMasterFields = linkMasterFields;
  }
  linkMaster(keyObj: any, order: string) {
    /*this.linkMasterReturn(keyObj, order).subscribe((data) => {
      this.itemList = data.obj;
    });*/
    this.linkMasterReturn(keyObj, order).subscribe({
      next: (value) => {
        // 處理正常的值
        this.setItemList(value.obj);
        console.log('linkMaster 讀取資料...');
      },
      error: (error) => {
        // 處理錯誤
        alert(this.tableName + ' 載入錯誤:' + error.message);
      },
      complete: () => {
        // 完成時執行（可選）
        console.log('linkMaster 完成');
      }
    });
  }
  linkMasterReturn(keyObj: any, order: string): Observable<any> {
    let where = '';
    this.linkKeyObj = keyObj;
    Object.keys(keyObj).forEach((e) => {
      where = where + ' AND (' + e + ' = ' + jkLib.quotedStr(keyObj[e]) + ') ';
    });
    if (order === '') {
      order = this.sqlOrder;
    }
    return this.loadByHttpClient(where, order);
  }
  setLinkKeyObjFromMasterItem(masterItem: any): any {
    this.linkKeyObj = jkLib.linkFieldSet2Object(this.linkMasterFields, masterItem);
    return this.linkKeyObj;
  }
  doOpenDetail(item: any, order: string): Observable<any> {
    if (this.linkMasterFields === '') {
      alert('doOpenDetail未設定主檔欄位連結(linkMasterFields)');
    }
    if (jkLib.isEmpty(item)) {
      alert('JkEntity:請先選一筆主檔記錄!(主檔無KEY值)');
      return of({ obj: [], result: false });
    }
    //this.linkKeyObj = jkLib.linkFieldSet2Object(
    //  this.linkMasterFields,
    //  item // 要含有主表的key
    //);
    this.setLinkKeyObjFromMasterItem(item);
    //this.linkMaster(this.linkKeyObj, order);
    //return this.loadByHttpClient(this.sqlWhere,this.sqlOrder);
    return this.linkMasterReturn(this.linkKeyObj, order);
  }
  haveMaster(): boolean {
    let bool = false;
    if (!this.linkKeyObj)
      return false;
    let data = this.linkKeyObj[this.keyFields[0]];
    if (data !== '') {
      bool = true;
    }
    return bool;
  }
  isAutoConfirm: boolean = false;
  /**
   * 非同步執行 回傳搭配 advCheckParse 使用
   * @param fieldName
   * @param item
   * @param mainTable
   * @param itemId
   * @param returnFields
   * @param params
   * @param errCode
   * @param errMessage
   * @returns
   */
  advCheckAsync(fieldName: string, item: any, mainTable: string, itemId: string, returnFields: string,
    params: any[], errCode: string, errMessage: string): Observable<jkRestReturn> {
    if (jkLib.paramsAllEmpty(params)) {
      return of(new jkRestReturnClass());// TODO:未測試
    }
    return this.orm.advCheckAsync(item, mainTable, itemId, params);
    /*.subscribe((ret:jkRestReturn) =>{
    this.validate.valid(ret.result, fieldName, validType.invalid, errMessage);
    if (!ret.result) {
      if (errCode === 'E')
        alert('錯誤:' + CR + errMessage + CR + JSON.stringify(params)); // ,'error'
      if (errCode === 'W')
        alert('警告:' + CR + errMessage + CR + JSON.stringify(params)); // page.showAlert(errMessage,'warning');
    }
    return ret.result;
    */
  }

  // errCode: E W N
  async advCheck(fieldName: string, item: any, mainTable: string, itemId: string, returnFields: string,
    params: any[], errCode: string, errMessage: string): Promise<boolean> {
    if (jkLib.paramsAllEmpty(params)) {
      return true;
    }
    let ret = await this.orm.advCheck(item, mainTable, itemId, returnFields, params, errCode);
    this.validate.valid(ret.result, fieldName, validType.invalid, errMessage);
    if (!ret.result) {
      if (errCode === 'E')
        alert('錯誤:' + CR + errMessage + CR + JSON.stringify(params)); // ,'error'
      if (errCode === 'W')
        alert('警告:' + CR + errMessage + CR + JSON.stringify(params)); // page.showAlert(errMessage,'warning');
    }
    return ret.result;

  }
  runSqlOpt(opt: SqlOption): Observable<any> {
    let sql = jkLib.prepareSQL(opt.makeSql(), opt.param, this.sysdbname, this.dbname);
    return this.orm.simpleSql(this.host, sql);
  }
  loadIdNameList(sqlOpt: SqlOption) { // lookup:idNameItem[]
    this.runSqlOpt(sqlOpt).subscribe({
      next: (value) => {
        // 處理正常的值
        this.idNameList = value;
      },
      error: (error) => {
        // 處理錯誤
        alert(this.tableName + ' 載入錯誤:' + error.message);
      },
      complete: () => {
        // 完成時執行（可選）
      }
    });
  }
  simpleSqlRx(sql: string): Observable<any> {
    return this.orm.simpleSql(this.host, sql);
  }
  async billNo(billType: string, date: string): Promise<string> {
    let r = await this.orm.autoNo('master', this.tableName, this.keyFields.join(','),
      billType, date);
    let no = '';
    return r.data;
  }
  /**
   * 從主表的key值讀取詳細資料
   * jackie 20250818 add
   * @param masterKeyValues 主表的key值
   * @returns
   */
  async loadDetailsByMasterKey(keyFields: string[], masterKeyValues: string[]): Promise<any[]> {
    this.sqlWhere = '';
    for (let i = 0; i < keyFields.length; i++) {
      this.sqlWhere += ` AND (${keyFields[i]} = ${jkLib.quotedStr(masterKeyValues[i])}) `;
    }

    //this.initBodyOpt('get', this.makeSql());

    return this.loadData();
  }
  getByKey(keyValues: any[]): Observable<any> {
    let where = '';
    for (let i = 0; i < keyValues.length; i++) {
      where += ` AND (${this.keyFields[i]} = ${jkLib.quotedStr(keyValues[i])}) `;
    }
    return this.loadByHttpClient(where, '');
  }

}
